import React__default from 'react';
import { CountryLocationContext } from '@invitae/nucleobase-engine-contentful';

var CountryLocationProvider = function (_a) {
    var countryCode = _a.countryCode, _b = _a.enableCountryLocationControls, enableCountryLocationControls = _b === void 0 ? false : _b, children = _a.children;
    if (!countryCode) {
        console.error('CountryLocationProvider - Missing `countryCode` in NucleobaseShell');
        return null;
    }
    return (React__default.createElement(CountryLocationContext.Provider, { value: { countryCode: countryCode, enableCountryLocationControls: enableCountryLocationControls } }, children));
};

export { CountryLocationProvider as default };
//# sourceMappingURL=CountryLocationProvider.esm.js.map
